export const preloadLivePagesComponents = async () => {
	return (
		await import(
			/* webpackChunkName: "loadable-livePages-preloader" */
			'./livePages-preloader'
		)
	).preloadLivePagesComponents();
};

export const preloadViewPageComponents = async (...args) => {
	return (
		await import(
			/* webpackChunkName: "loadable-viewPage-preloader" */
			'./view-page'
		)
	).preloadViewPage(...args);
};

export const preloadSpaceOverview = async () => {
	(
		await import(/* webpackChunkName: "loadable-preloadersspace-overview" */ './space-overview')
	).preloadSpaceOverview();
};

export const preloadSearch = async () => {
	(await import(/* webpackChunkName: "loadable-preloaderssearch" */ './search')).preloadSearch();
};

export const preloadHome = async (...args) => {
	(await import(/* webpackChunkName: "loadable-preloadershome" */ './home')).preloadHome(...args);
};

export const preloadNativeEditorComponentsPreloader = async () => {
	(
		await import(
			/* webpackChunkName: "loadable-nativeEditorComponentsPreloader" */ '@confluence-classic/confluence-fabric-editor/src/lib'
		)
	).nativeEditorComponentsPreloader();
};

export const preloadCreateContent = async () => {
	(
		await import(/* webpackChunkName: "loadable-preloaderscreate-content" */ './create-content')
	).preloadCreateContentRoute();
};

export const preloadWhiteboardPage = async () => {
	(
		await import(/* webpackChunkName: "loadable-preloaderswhiteboard-page" */ './whiteboard-page')
	).preloadWhiteboardPage();
};
